<template>
  <div class="fileuploader-container">
    <form class="image-form">
      <img
        id="imageThumbnail"
        :src="this.imageSource"
        alt="your image"
        width="200"
        height="200"
        @click="previewImageHandler"
      />
      <!-- <div class="annotation"><b>Requires 512px x 512px</b></div> -->
      <!--Might need to expose this as a prop -->
    </form>
    <gc-popup
      :popup-visible="previewVisible"
      popup-title="Image Preview"
      :popup-height="520"
      :wrapperAttr="{ class: 'css-v2 gc-popup' }"
      :back-button-function="() => (previewVisible = false)"
      :saveButtonConfig="saveButtonConfig"
    >
      <div class="css-v2 gc-popup-form">
        <img
          id="imagePreview"
          :src="this.previewImageSource"
          alt="Company Logo"
          height="400"
        />
      </div>
    </gc-popup>

    <div class="uploader">
      <DxFileUploader
        select-button-text="Upload"
        label-text=""
        accept="image/*"
        upload-mode="instantly"
        @value-changed="onValueChanged"
        :show-file-list="false"
        :read-only="baseView.mode == 'review'"
      />
    </div>
  </div>
</template>

<script>
import { DxFileUploader } from "devextreme-vue/file-uploader";
import RouteMixin from "@/_mixins/route.mixin";
import appConfig from "../app-config";

export default {
  mixins: [RouteMixin],
  components: {
    DxFileUploader,
  },
  data() {
    return {
      previewVisible: false,
    };
  },
  props: {
    dataModel: {
      type: Object,
      default: () => {},
    },
    imageUploaderOptions: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    saveButtonConfig() {
      return {
        text: "Download",
        type: "default",
        clickCallback: async () => {
          // var blobName = "a174a33a-8203-4d25-80bb-413cf03f36f9.png";
          var blobName = this.dataModel.OriginalImageBlobName;
          var blobUrl = `${appConfig.VUE_APP_ROOT_API}/api/CompanyImage/${blobName}/download`;

          Object.assign(document.createElement("a"), {
            target: "_blank",
            href: blobUrl,
          }).click();
        },
      };
    },
    imageSource() {
      if (this.dataModel.ImageSrc) return `${this.dataModel.ImageSrc}`;

      let baseUrl = process.env.VUE_APP_BASE_URL;
      if (baseUrl === "/")
        return `${baseUrl}statics/company-logo-placeholder.png`;
      else return `/${baseUrl}/company-logo-placeholder.png`;
    },

    previewImageSource() {
      return `${this.dataModel.PreviewImageSrc}`;
    },
  },

  methods: {
    previewImageHandler() {
      this.previewVisible = !this.previewVisible;
    },
    onValueChanged(e) {
      let that = this;
      if (e.value.length) {
        let img = new Image();
        img.src = window.URL.createObjectURL(event.target.files[0]);
        that.dataModel["ImageType"] = e.value[0].type;
        that.dataModel["ImageName"] = e.value[0].name;

        img.onload = () => {
          var reader = new FileReader();

          reader.onload = function(e) {
            let imageStr = e.target.result;
            document.getElementById("imageThumbnail").src = imageStr;

            let index = imageStr.indexOf("base64");
            imageStr = imageStr.substring(index + 7);

            that.dataModel[that.imageUploaderOptions.dataField] = imageStr;
          };
          reader.readAsDataURL(e.value[0]);
        };
      }
    },
  },
};
</script>

<style lang="scss">
.fileuploader-container {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.uploader {
  .dx-widget.dx-fileuploader {
    height: 100%;
    .dx-fileuploader-input-wrapper {
      height: 100%;
    }
  }
  .dx-button {
    border-radius: 4px;
    background-color: #03a9f4 !important;
    color: #fff;
    display: flex;
    flex-direction: column;
  }
}

.dx-fileuploader-input-wrapper {
  position: relative;
}

.dx-fileuploader-button.dx-button {
  position: absolute;
  bottom: 0;
}

.image-form {
  display: flex;
  flex-direction: column;
}

.annotation {
  margin-left: 30px;
  margin-top: 10px;
}

#imageThumbnail {
  cursor: pointer;
}

#imagePreview {
  margin: auto;
  display: block;
}
</style>
